export default __webpack_public_path__ + "static/media/communication_log_icon.dd48e589.svg";